<template>

	<div class="m-dig-bg">
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>

		<div class="waterfull">
			<div class="info_tit">
				<div class="tit_left">
					<span>数字文物 </span>
					<el-divider direction="vertical"></el-divider>
					<span>Digital cultural relics</span>
				</div>

			</div>

			<div class="v-waterfall-content" id="v-waterfall">
				<div class="v-waterfall-1">
					<div v-for="(item, index) in list1" :key="index" class="v-waterfall-item"
						:style="{width:waterfallImgWidth+'px'}" @click="go(item)">
						<img class="pointer pointer_img css3" :src="item.image" alt="" />
						<p class="title pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
						<p class="digest pointer">{{lang=='CN' ?item.cn_digest:item.en_digest}}</p>
					</div>
				</div>
				<div class="v-waterfall-2">
					<div v-for="(item, index) in list2" :key="index" class="v-waterfall-item"
						:style="{width:waterfallImgWidth+'px'}" @click="go(item)">
						<img class="pointer pointer_img css3" :src="item.image" alt="" />
						<p class="title pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
						<p class="digest pointer">{{lang=='CN' ?item.cn_digest:item.en_digest}}</p>
					</div>
				</div>
				<div class="v-waterfall-3">
					<div v-for="(item, index) in list3" :key="index" class="v-waterfall-item"
						:style="{width:waterfallImgWidth+'px'}" @click="go(item)">
						<img class="pointer pointer_img css3" :src="item.image" alt="" />
						<p class="title pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
						<p class="digest pointer">{{lang=='CN' ?item.cn_digest:item.en_digest}}</p>
					</div>
				</div>
				<div class="v-waterfall-4">
					<div v-for="(item, index) in list4" :key="index" class="v-waterfall-item"
						:style="{width:waterfallImgWidth+'px'}" @click="go(item)">
						<img class="pointer pointer_img css3" :src="item.image" alt="" />
						<p class="title pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
						<p class="digest pointer">{{lang=='CN' ?item.cn_digest:item.en_digest}}</p>
					</div>
				</div>
			</div>
			
			<!-- 分页 -->
			<div class="fenye">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" background :page-size="per_page"
					layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		archives_list
	} from '@/api/api.js'
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'

	export default {
		components: {
			Header,
			Footer
		},
		name: 'digital_cultural_legacy',
		data() {
			return {
				keyword: '',
				per_page: 10,
				page: 1,
				total:0,
				currentPage:1,
				lang: localStorage.getItem('lang') || 'CN',
				waterfallList: [],
				waterfallImgWidth: 300,
				list1: [],
				list2: [],
				list3: [],
				list4: [],
			}
		},
		created() {
			this.getCateglory();
		},
		mounted() {
		},
		methods: {
			toggleNext(index) {},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			go(item) {
				this.$router.push({
					path: `digital_cultural_detail?id=${item.id}`
				})
			},
			getCateglory() {
				//获取二级栏目
				let data = {
					channel_id: 54,
					per_page: this.per_page,
					page: this.page,
					keyword: this.keyword,
				}
				archives_list(data).then(res => {
					if (res.code == 1) {
						let list1 = [],
							list2 = [],
							list3 = [],
							list4 = []
						this.waterfallList = res.data.data
						this.total=res.data.total
						this.waterfallList.map((item, index) => {
							if (index % 4 == 0) {
								list1.push(item)
							}
							if (index % 4 == 1) {
								list2.push(item)
							}
							if (index % 4 == 2) {
								list3.push(item)
							}
							if (index % 4 == 3) {
								list4.push(item)
							}
						})
						this.list1 = list1
						this.list2 = list2
						this.list3 = list3
						this.list4 = list4
					}
				}).catch(err => {});
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.getCateglory();
				console.log(`当前页: ${val}`);
			},
		}
	}
	
	
</script>

<style lang="scss" scoped>
	.m-dig-bg {
		background-color: #668b78;
	}
	.waterfull {
		background-color: #FFFFFF;
		max-width: 1400px;
		padding: 15px;
		margin: 20px auto;
		min-height: 400px;

		/**通用标题 */
		.info_tit {
			padding: 0 20px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			margin-top: 10px;
			cursor: pointer;
		}

		.info_tit .active {
			border: 2px solid #006170;
			box-shadow: 5px 7px 10px #cddadc;
			color: #000;
		}

		.info_tit .tit_left span:first-child {
			font-size: 30px;
			color: #000;
			font-weight: bold;
		}

		.info_tit .tit_left span:last-child {
			font-size: 14px;
			color: #999;
		}



		.v-waterfall-content {
			/* 主要 */
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			margin-top: 20px;
			justify-content: space-around;
			// height: 400px;
			position: relative;

			/* 次要：设置滚动条，要求固定高度 */
			// overflow-y: auto;
			.v-waterfall-1,
			.v-waterfall-2,
			.v-waterfall-3,
			.v-waterfall-4 {
				width: 300px;
			}
		}
		.fenye {
			margin-top: 50px;
			text-align: center;
		}
	}

	.pointer_img:hover {
		transform: scale(1.1, 1.1);
		overflow: hidden;
	}

	// 瀑布样式
	.v-waterfall-item {
		/* 主要 */
		float: left;
		margin-bottom: 10px;

		// position: absolute;
		img {
			/* 主要 */
			/* width: auto;height: auto; */
			// width: 90%;
			width: 100%;
			height: auto;
			/* 次要 */
			border-radius: 6px;
			margin-bottom: 15px;
		}

		.title {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			line-height: 30px;
			color: #1A1A1A;
			font-size: 18px;
		}

		.digest {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			font-size: 14px;
			color: #666666;
		}

		.title:hover,
		.digest:hover {
			color: #c1925b;
		}

		p:hover {
			background: none;
		}
	}
</style>
